var paywall = require("./lib/paywall");
setTimeout(() => paywall(12313139), 5000);

require("component-leaflet-map");
require("component-responsive-frame");

// data
var data = require("./hospital.geo.json");

// dom elements
var map_element = document.getElementById("facility-map"),
	map_dots = document.getElementsByClassName("leaflet-interactive"),
	inspections = document.querySelectorAll(".inspection"),
	dc_embed = document.querySelector("#dc-embed"),
	hospital_selector = document.querySelector("#hospital-selector"),
	inspection_selectors = document.querySelectorAll(".inspection-selector"),
	hospital_divs = document.querySelectorAll(".hospital");

// functions
var show_hospital = function(code) {
	var selected_hospital_divs = document.querySelectorAll(".hospital[data-hospital=" + code + "]");

	Array.from(hospital_divs).forEach(div => {
		div.classList.remove("shown");
		div.classList.add("hidden");
	});
	
	Array.from(selected_hospital_divs).forEach(div => {
		div.classList.remove("hidden");
		div.classList.add("shown");
	});

	var selector = document.getElementById("inspection-selector--" + code),
		dc_html = selector.options[0].getAttribute("data-document"),
		dc_js = dc_html.split(".html")[0] + ".js";

		show_document(dc_js);
}

var highlight_dot = function(code) {
	Array.from(map_dots).forEach(dot => {
		dot.classList.remove("highlighted");
	});

	var this_dot = document.querySelector(".leaflet-interactive." + code);
	this_dot.classList.add("highlighted");
}

var show_document = function(doc) {
	DV.load(doc, {
		responsive: true,
		sidebar: false,
		text: false,
		container: "#dc-embed"
	});
}

// create leaflet map
var L = map_element.leaflet,
  map = map_element.map,
  allLayers = [];

var onEachFeature = function(feature, layer) {
	var hospital = feature.properties.facility,
    hospital_code = hospital.replace(/[^a-zA-Z0-9]/g,'_');

  allLayers.push(layer);
  feature.layer = layer;

  layer.bindTooltip(hospital);

  layer.on('click', function(e) {
    hospital_selector.value = hospital;
    show_hospital(hospital_code);
    highlight_dot(hospital_code);

    allLayers.forEach(function(l) {
      l.setStyle({ weight: 1, fillOpacity: 0.7 });  
    });

    layer.setStyle({ weight: 2.5, fillOpacity: 1 });
  });
};

function geojsonMarkerOptions(feature) {
  return {
    radius: 7,
    fillColor: "#f15a29",
    color: "#000000",
    weight: 1,
    opacity: 0.7,
    fillOpacity: 0.7,
    className: feature.properties.facility.replace(/[^a-zA-Z0-9]/g,'_')
  }
};

var geojson = L.geoJson(data, {
    pointToLayer: function (feature, latlng) {
      var marker = L.circleMarker([latlng.lat, latlng.lng]);
      return marker;
    },
    style: geojsonMarkerOptions,
    onEachFeature: onEachFeature
}).addTo(map);

map.scrollWheelZoom.disable();

// event listeners
hospital_selector.addEventListener('change', function(e) {
	e.preventDefault();

	var val = hospital_selector.value,
		code = val.replace(/[^a-zA-Z0-9]/g,'_');
	
	show_hospital(code);
	highlight_dot(code);
});

Array.from(inspections).forEach(button => {
	button.addEventListener("click", function() {
		Array.from(inspections).forEach(i => {
			i.classList.remove("highlighted");
		});

		this.classList.add("highlighted");

		var dc_html = this.dataset.document,
		dc_js = dc_html.split(".html")[0] + ".js";

		show_document(dc_js);
	});
});

Array.from(inspection_selectors).forEach(selector => {
	selector.addEventListener('change', function(e) {
		e.preventDefault();

		var dc_html = this.options[this.selectedIndex].getAttribute('data-document'),
			dc_js = dc_html.split(".html")[0] + ".js";

		show_document(dc_js);
	});
})

// on page load, show first hospital and first document
show_hospital("BHC_Fairfax_Hospital__Everett_");

DV.load('https://www.documentcloud.org/documents/6154074-Fairfax-Everett-062218-State-Licensure.js', {
  responsive: true,
	sidebar: false,
	text: false,
	container: "#dc-embed"
});